import React, { useState } from "react";
import { Card, CardHeader, formatCurrency } from "../../../UI/DesignStandards";
import { dueTotal } from "../../../../utility/signupDashboard";
import AverageProofViewer from "../../../Signup/AverageProofViewer";
import SignupCard from "./SignupCard";

const emptyCopy = (count) =>
  count === 0
    ? "No signups yet."
    : "No signups match these filters.";

const SignupList = ({
  signups,
  allSignups,
  actionId,
  onViewSignup,
  onMarkPaid,
  onMarkUnpaid,
}) => {
  const [proofPath, setProofPath] = useState("");
  const owed = dueTotal(signups);

  if (signups.length === 0) {
    return (
      <Card>
        <CardHeader title="Signups (0)" />
        <div className="p-6">
          <p className="text-center py-8 text-brand-muted">
            {emptyCopy(allSignups?.length || 0)}
          </p>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={`Signups (${signups.length})`}
        subtitle={owed > 0 ? `Due ${formatCurrency(owed)}` : undefined}
      />
      <div className="p-6">
        <div className="space-y-4">
          {signups.map((signup) => (
            <SignupCard
              key={signup.id}
              signup={signup}
              signups={allSignups || signups}
              actionLoading={actionId === signup.id}
              onViewSignup={onViewSignup}
              onViewAverageProof={(signup) =>
                setProofPath(signup.averageProofPath || "")
              }
              onMarkPaid={onMarkPaid}
              onMarkUnpaid={onMarkUnpaid}
            />
          ))}
        </div>
      </div>
      <AverageProofViewer
        isOpen={Boolean(proofPath)}
        onClose={() => setProofPath("")}
        storagePath={proofPath}
      />
    </Card>
  );
};

export default SignupList;
